// src/config/translations.js

export const translations = {
  fr: {
    // Catégories dépenses
    catFinancement: "Financement",
    catAssurance: "Assurance",
    catControle: "Contrôle technique",
    catGarage: "Garage",
    catPeage: "Péage",
    catLavage: "Lavage",
    catContravention: "Contravention",
    catParking: "Parking",
    // Navigation
    accueil: "Accueil",
    checklist: "Checklist",
    documents: "Dossiers",
    depenses: "Dépenses",
    historique: "Diagnostic",
    rapport: "Rapport",
    secours: "🆘 Secours",
    verifie: "vérifiés",

    // Accueil
    ajouterVehicule: "+ AJOUTER UN VÉHICULE",
    type: "TYPE",
    nom: "NOM",
    immatriculation: "IMMATRICULATION",
    ajouterBtn: "+ Ajouter le véhicule",
    nouveau: "+ Nouveau",
    toutRoule: "✅ Tout roule !",
    aSurveiller: "⏳ À surveiller",
    unSouci: "⚠️ Y'a un souci !",
    etatVehicule: "ÉTAT DU VÉHICULE",
    derniereVerif: "DERNIÈRE VÉRIF",
    score: "SCORE",
    ok: "OK",
    bientot: "BIENTÔT",
    probleme: "PROBLÈME",
    onFaitLeTour: "On fait le tour ?",
    rappels: "RAPPELS",
    expire: "Expiré 🔴",
    dans: "Dans",
    jours: "jours",
    unitKm: "km",
    boutonSecours: "BOUTON DE SECOURS",
    accidentAssistanceConstat: "Accident · Assistance · Constat · Services proches",
    photo: "Photo",
    changer: "Changer",

    // Checklist
    commentCaSePassee: "COMMENT ÇA SE PASSE ?",
    voirLeBilan: "Voir le bilan",
    choisirVehicule: "Choisis un véhicule depuis l'accueil",

    // Documents
    choisirVehiculeDocs: "Choisis un véhicule pour lier tes docs.",
    assurance: "🛡️ Assurance",
    controleTechnique: "🚗 Contrôle Technique",
    garage: "🔧 Garage",
    modifierAssurance: "✏️ Modifier l'assurance",
    ajouterAssurance: "➕ Ajouter l'assurance",
    organisme: "ORGANISME",
    contrat: "N° CONTRAT",
    telephone: "TÉLÉPHONE",
    dateEcheance: "DATE D'ÉCHÉANCE",
    enregistrer: "✅ Enregistrer",
    annuler: "✕ Annuler",
    appelerAssurance: "Appeler l'assurance",
    appelerGarage: "Appeler le garage",
    modifierControle: "✏️ Modifier le contrôle",
    ajouterControle: "➕ Ajouter le contrôle technique",
    modifierGarage: "✏️ Modifier le garage",
    ajouterGarage: "➕ Ajouter le garage",
    nomGarage: "NOM DU GARAGE",
    enregistrerInfos: "💾 Enregistrer les infos",
    enregistre: "✅ Enregistré !",
    modifierRevision: "✏️ Modifier la révision",
    ajouterRevision: "➕ Ajouter une révision",
    revision: "Révision",
    dateProchaineRevision: "DATE DE LA PROCHAINE RÉVISION",
    enregistrerRevision: "✅ Enregistrer la révision",
    coordonnees: "📋 COORDONNÉES",
    echeance: "📅 ÉCHÉANCE",
    dateEcheanceLabel: "Date d'échéance",
    nouvelleDateEcheance: "NOUVELLE DATE D'ÉCHÉANCE",
    ajouterDabordAssurance: "Ajoutez d'abord vos coordonnées d'assurance",
    voirGoogleMaps: "📍 Voir sur Google Maps",
    prochaineRevision: "Prochaine révision",
    kmProchaineRevision: "KM DE LA PROCHAINE RÉVISION",
    modifierCoordonnees: "Modifier les coordonnées",
    facturesDocuments: "📁 Factures & documents",
    ajouterFacture: "Ajouter une facture",
    pdfImageDoc: "PDF, image, ou tout document",
    aucuneFacture: "Pas encore de facture 📄",
    expireDans: "Expire dans",
    expireExclam: "Expiré 🔴",
    urgent: "Urgent ⚠️",
    bientotLabel: "Bientôt ⏳",
    okLabel: "OK ✅",
    depasse: "Dépassée !",
    revisionDue: "Révision due !",

    // Dépenses
    ceMoisCi: "CE MOIS-CI",
    general: "📋 Général",
    carburant: "⛽ Carburant",
    ajouterDepense: "➕ Ajouter une dépense",
    ajouterPlein: "➕ Ajouter un plein",
    date: "DATE",
    categorie: "CATÉGORIE",
    montant: "MONTANT (€)",
    description: "DESCRIPTION",
    kilometrage: "KILOMÉTRAGE",
    prix: "PRIX (€)",
    enregistrerDepense: "✅ Enregistrer",
    enregistrerPlein: "✅ Enregistrer le plein",
    rienIci: "Rien ici pour l'instant 💸",
      premierPlein: "Premier plein à enregistrer ⛽",
    coutAuKm: "COÛT AU KM",
    moyenne: "Moyenne",
    consoParMois: "Consommation par mois (L/100km)",
    consomMois: "Consommation",
    moyAbrev: "Moy.",
    anneeVue: "Année",
    moisVue: "Mois",

    // Historique
    pasDeVerif: "Pas encore de vérif ici",
    lancerChecklist: "Lance ta première checklist !",
    historiqueVerifs: "HISTORIQUE DES VÉRIFICATIONS",
    obd2Desc: "Connectez un boîtier OBD2 pour lire les codes d'erreur de votre véhicule, surveiller les paramètres moteur en temps réel et détecter les pannes avant qu'elles arrivent.",
    bientotDispo: "Bientôt disponible",
    obd2Soon: "Prochainement",
    connecterOBD2: "Connecter un OBD2",
    diagBientot: "Les fonctions diagnostic de cette page seront bientôt disponibles",
    diagIATitre: "DIAGNOSTIC IA — VOYANTS",
    diagIASous: "Prends une photo de ton tableau de bord",
    diagPrendrePhoto: "Prendre une photo",
    diagDashboard: "Tableau de bord · Voyants",
    diagAnalyser: "🔍 Analyser",
    diagAucunVoyant: "Aucun voyant allumé détecté !",
    diagErreur: "Impossible d'analyser la photo. Réessayez.",

    // Rapport
    rapportInspection: "Rapport d'inspection",
    genere: "Généré le",
    a: "à",
    telechargerPDF: "📄 Télécharger le rapport (PDF)",
    aRegler: "⚠️ À régler",
    aNePasOublier: "📅 À ne pas oublier",
    qrCode: "📱 QR CODE — HISTORIQUE GARAGE",
    scannerQR: "Scannez pour voir l'historique des interventions garage",
    intervention: "intervention",
    interventions: "interventions",

    // Secours steps FR
    accStep1Title: "Sécuriser la zone",
    accStep1Desc: "Coupez le moteur. Mettez le gilet jaune AVANT de sortir du véhicule. Placez le triangle à 30m minimum.",
    accStep2Title: "Vérifier les blessés",
    accStep2Desc: "Si blessé grave : appelez le 15 (SAMU) ou le 18 (pompiers). Ne déplacez pas les blessés.",
    accStep3Title: "Appeler les secours",
    accStep3Desc: "Police/Gendarmerie : 17 · SAMU : 15 · Pompiers : 18 · Numéro européen : 112",
    accStep4Title: "Contacter l'assurance",
    accStep4Desc: "Déclarez le sinistre dans les 5 jours ouvrés. Remplissez le constat à l'amiable.",
    conStep1Title: "Date, heure et lieu",
    conStep1Desc: "Notez la date, l'heure exacte et le lieu précis de l'accident.",
    conStep2Title: "Blessés ?",
    conStep2Desc: "Indiquez s'il y a des blessés, même légers.",
    conStep3Title: "Dommages matériels",
    conStep3Desc: "Cochez si d'autres véhicules ou objets sont endommagés.",
    conStep4Title: "Témoins",
    conStep4Desc: "Notez les noms et coordonnées des témoins.",
    conStep5Title: "Véhicule A & B",
    conStep5Desc: "Chaque conducteur remplit SA colonne. Vérifiez les infos de l'autre.",
    conStep6Title: "Assurances",
    conStep6Desc: "Échangez numéros de contrat, noms des assureurs et coordonnées.",
    conStep7Title: "Croquis de l'accident",
    conStep7Desc: "Faites un schéma simple : position des véhicules, sens de circulation.",
    conStep8Title: "Signatures obligatoires",
    conStep8Desc: "Les DEUX conducteurs doivent signer. Chacun garde son exemplaire.",
    conStep9Title: "Ne jamais reconnaître sa faute",
    conStep9Desc: "Ne signez aucun document sans l'accord de votre assureur.",
    // Véhicule modification
    modifierVehicule: "✏️ Modifier le véhicule",
    enregistrerVehicule: "✅ Enregistrer",
    // Carburant litres
    litres: "LITRES",
    consoMoyenne: "CONSO MOYENNE",
    // À propos
    aPropos: "À propos",
    version: "Version",
    carnetEntretien: "Carnet d'entretien intelligent",
    compteConnecte: "Compte connecté",
    disponiblePremium: "🔒 Disponible avec Premium",
    famille: "Famille",
    installerApp: "📲 Installer l'app sur le téléphone",
    installerAppUltra: "💎 Installer l'app (Ultra)",
    notifActivees: "🔔 Notifications activées ✓",
    activerNotif: "🔔 Activer les notifications",
    notifPushUltra: "💎 Notifications push (Ultra)",
    confirmerSuppression: "⚠️ Confirmer la suppression",
    actionIrreversibleMdp: "Cette action est irréversible. Entrez votre mot de passe pour confirmer.",
    votreMdp: "Votre mot de passe",
    supprimer: "🗑️ Supprimer",
    partagerAppTexte: "L'appli carnet d'entretien pour ton véhicule 🚗",
    lienCopie: "✅ Lien copié !",
    partagerApp: "🔗 Partager l'app",
    cguPolitique: "📄 CGU & Politique de confidentialité",
    // Supprimer compte
    supprimerCompte: "Supprimer mon compte",
    supprimerCompteConfirm: "Êtes-vous sûr ? Cette action est irréversible.",
    supprimerCompteBtn: "🗑️ Supprimer définitivement",
    // Secours
    resteCalme: "Reste calme, on est là. 👊",
    enCasAccident: "En cas d'accident",
    procedureSecurite: "Procédure · Sécurité · Assistance",
    guideConstat: "Guide constat européen",
    remplirSansErreur: "Remplir sans erreur étape par étape",
    servicesProches: "Services proches",
    googleMapsOuvre: "Google Maps s'ouvre près de toi 📍",
    retour: "← Retour",
    // Certificat
    certificatEntretien: "🔗 CERTIFICAT D'ENTRETIEN",
    bientotBlockchain: "Powered by CHECKAR — Bientôt sur Blockchain",
    idCertificat: "ID CERTIFICAT",
    verifications: "Vérifications",
    interventions: "Interventions",
    genere: "Généré le",
    scannerCertificat: "Scannez ce QR code pour vérifier l'authenticité du carnet d'entretien",
    // Plans Premium
    planTitre: "Choisir un plan",
    planSoustitre: "Passez à la vitesse supérieure 🚀",
    planPopulaire: "⭐ LE PLUS POPULAIRE",
    planMois: "/mois",
    planOu: "ou",
    planAn: "/an",
    planGratuit: "Gratuit",
    planActuel: "Votre plan actuel",
    planPremiumBtn: "Passer Premium 🔒",
    planUltraBtn: "Passer Ultra Premium 💎",
    planSupportTitre: "⚡ Support prioritaire Ultra Premium",
    planSupportDesc: "Réponse garantie sous 24h par email. Nos équipes traitent vos demandes en priorité absolue.",
    planFooter: "Paiement sécurisé · Sans engagement · Résiliable à tout moment",
    planFreeF1: "1 véhicule", planFreeF2: "Checklist complète", planFreeF3: "Documents & rappels",
    planFreeF4: "Bouton secours 🆘", planFreeF5: "Dépenses — mois en cours", planFreeF6: "Statistiques — mois en cours",
    planPremF0: "Tout le gratuit +", planPremF1: "Jusqu'à 3 véhicules", planPremF2: "Multilingue FR/EN (auto) 🌍", planPremF3: "Certificat & rapport PDF 📄",
    planPremF4: "Dépenses & km — 3 mois", planPremF5: "Historique — 3 mois", planPremF6: "Partage familial par code 👨‍👩‍👧",
    planPremF7: "Export PDF 📄", planPremF8: "Statistiques — 3 mois",
    planUltraF1: "Véhicules illimités", planUltraF2: "Tout du Premium +", planUltraF3: "PWA installable 📲",
    planUltraF4: "Notifications push 🔔", planUltraF5: "Dépenses & km illimité", planUltraF6: "Historique illimité",
    planUltraF7: "Export PDF + Scanner OCR 📷", planUltraF8: "Diagnostic OBD2 🔌",
    planUltraF9: "Support prioritaire ⚡ (24h)", planUltraF10: "Statistiques — 1 an",
    // Scanner OCR
    scannerFacture: "📷 Scanner une facture",
    analyseEnCours: "⏳ Analyse en cours...",
    // Bienvenue
    bienvenue: "Bienvenue sur CHECKAR ! 🚗",
    bienvenueMsg: "Commencez par ajouter votre véhicule pour suivre son entretien.",
    // Kilométrage
    kilometrage: "Kilométrage",
    kmActuel: "KM ACTUEL",
    procedureAccident: "🚨 Procédure accident",
    appelRapide: "APPEL RAPIDE",
    pompiers: "Pompiers",
    police: "Police",
    europe: "Europe",
    assuranceLabel: "Assurance",
    numerosUrgence: "NUMÉROS D'URGENCE",
    pasNumeroAssurance: "📋 Pas de numéro d'assurance enregistré",
    guideConstatTitle: "📋 Guide constat européen",
    servicesProchesTitle: "📍 Services proches",
    garageDépannage: "Garage / Dépannage",
    stationService: "Station service",
  },

  en: {
    // Catégories dépenses
    catFinancement: "Financing",
    catAssurance: "Insurance",
    catControle: "MOT / Inspection",
    catGarage: "Garage",
    catPeage: "Toll",
    catLavage: "Car wash",
    catContravention: "Fine",
    catParking: "Parking",
    // Navigation
    accueil: "Home",
    checklist: "Checklist",
    documents: "Files",
    depenses: "Expenses",
    historique: "Diagnostic",
    rapport: "Report",
    secours: "🆘 Emergency",
    verifie: "checked",

    // Accueil
    ajouterVehicule: "+ ADD A VEHICLE",
    type: "TYPE",
    nom: "NAME",
    immatriculation: "LICENSE PLATE",
    ajouterBtn: "+ Add vehicle",
    nouveau: "+ New",
    toutRoule: "✅ All good!",
    aSurveiller: "⏳ Keep an eye on it",
    unSouci: "⚠️ There's an issue!",
    etatVehicule: "VEHICLE STATUS",
    derniereVerif: "LAST CHECK",
    score: "SCORE",
    ok: "OK",
    bientot: "SOON",
    probleme: "ISSUE",
    onFaitLeTour: "Run a check?",
    rappels: "REMINDERS",
    expire: "Expired 🔴",
    dans: "In",
    jours: "days",
    unitKm: "Miles",
    boutonSecours: "EMERGENCY BUTTON",
    accidentAssistanceConstat: "Accident · Assistance · Report · Nearby services",
    photo: "Photo",
    changer: "Change",

    // Checklist
    commentCaSePassee: "HOW'S IT LOOKING?",
    voirLeBilan: "See report",
    choisirVehicule: "Pick a vehicle from home",

    // Documents
    choisirVehiculeDocs: "Pick a vehicle to link your docs.",
    assurance: "🛡️ Insurance",
    controleTechnique: "🚗 MOT / Inspection",
    garage: "🔧 Garage",
    modifierAssurance: "✏️ Edit insurance",
    ajouterAssurance: "➕ Add insurance",
    organisme: "INSURER",
    contrat: "POLICY NUMBER",
    telephone: "PHONE",
    dateEcheance: "EXPIRY DATE",
    enregistrer: "✅ Save",
    annuler: "✕ Cancel",
    appelerAssurance: "Call insurance",
    appelerGarage: "Call garage",
    modifierControle: "✏️ Edit inspection",
    ajouterControle: "➕ Add MOT / Inspection",
    modifierGarage: "✏️ Edit garage",
    ajouterGarage: "➕ Add garage",
    nomGarage: "GARAGE NAME",
    enregistrerInfos: "💾 Save info",
    enregistre: "✅ Saved!",
    modifierRevision: "✏️ Edit service",
    ajouterRevision: "➕ Add a service",
    coordonnees: "📋 DETAILS",
    echeance: "📅 EXPIRY",
    dateEcheanceLabel: "Expiry date",
    nouvelleDateEcheance: "NEW EXPIRY DATE",
    ajouterDabordAssurance: "Add your insurance details first",
    voirGoogleMaps: "📍 View on Google Maps",
    prochaineRevision: "Next service",
    kmProchaineRevision: "NEXT SERVICE KM",
    modifierCoordonnees: "Edit details",
    voiture: "Car",
    moto: "Motorcycle",
    ajouterVehiculeBtn: "Add vehicle",
    modifierCoordonnees: "Edit details",
    modifierDate: "Edit date",
    confirmerModification: "Confirm edit?",
    modifier: "Edit",
    certificatEntretien: "🔗 MAINTENANCE CERTIFICATE",
    poweredBy: "Powered by CHECKAR — Soon on Blockchain",
    idCertificat: "CERTIFICATE ID",
    interventionsGarage: "Garage services",
    genereLe: "Generated on",
    scanQR: "Scan this QR code to see the full service history",
    partagerCertificat: "📤 Share certificate",
    voiciCertificat: "Here is the maintenance certificate for my vehicle ",
    lienCopie: "Link copied!",
    fermer: "Close",
    probleme: "PROBLEM",
    revision: "Service",
    dateProchaineRevision: "NEXT SERVICE DATE",
    enregistrerRevision: "✅ Save service",
    facturesDocuments: "📁 Invoices & documents",
    ajouterFacture: "Add an invoice",
    pdfImageDoc: "PDF, image, or any document",
    aucuneFacture: "No invoices yet 📄",
    expireDans: "Expires in",
    expireExclam: "Expired 🔴",
    urgent: "Urgent ⚠️",
    bientotLabel: "Soon ⏳",
    okLabel: "OK ✅",
    depasse: "Overdue!",
    revisionDue: "Service due!",

    // Dépenses
    ceMoisCi: "THIS MONTH",
    general: "📋 General",
    carburant: "⛽ Fuel",
    ajouterDepense: "➕ Add expense",
    ajouterPlein: "➕ Add fuel",
    date: "DATE",
    categorie: "CATEGORY",
    montant: "AMOUNT (€)",
    description: "DESCRIPTION",
    kilometrage: "MILEAGE",
    prix: "PRICE (€)",
    enregistrerDepense: "✅ Save",
    enregistrerPlein: "✅ Save fuel",
    rienIci: "Nothing here yet 💸",
    premierPlein: "Add your first fuel stop ⛽",
    coutAuKm: "COST PER MILE",
    moyenne: "Average",
    consoParMois: "Monthly consumption (L/100Miles)",
    consomMois: "Consumption",
    moyAbrev: "Avg.",
    anneeVue: "Year",
    moisVue: "Month",

    // Historique
    pasDeVerif: "No checks yet",
    lancerChecklist: "Run your first checklist!",
    historiqueVerifs: "CHECK HISTORY",
    obd2Desc: "Connect an OBD2 dongle to read your vehicle's fault codes, monitor engine parameters in real time and detect issues before they happen.",
    bientotDispo: "Coming soon",
    obd2Soon: "Coming soon",
    connecterOBD2: "Connect OBD2",
    diagBientot: "The diagnostic features on this page will be available soon",
    diagIATitre: "AI DIAGNOSTIC — WARNING LIGHTS",
    diagIASous: "Take a photo of your dashboard",
    diagPrendrePhoto: "Take a photo",
    diagDashboard: "Dashboard · Warning lights",
    diagAnalyser: "🔍 Analyse",
    diagAucunVoyant: "No warning lights detected!",
    diagErreur: "Unable to analyse the photo. Please try again.",

    // Rapport
    rapportInspection: "Inspection report",
    genere: "Generated on",
    a: "at",
    telechargerPDF: "📄 Download report (PDF)",
    aRegler: "⚠️ To fix",
    aNePasOublier: "📅 Don't forget",
    qrCode: "📱 QR CODE — GARAGE HISTORY",
    scannerQR: "Scan to see garage service history",
    intervention: "service",
    interventions: "services",

    // Secours steps EN
    accStep1Title: "Secure the area",
    accStep1Desc: "Turn off the engine. Put on the yellow vest BEFORE getting out. Place the triangle at least 30m away.",
    accStep2Title: "Check for injuries",
    accStep2Desc: "If seriously injured: call 15 (SAMU) or 18 (fire brigade). Do not move the injured.",
    accStep3Title: "Call emergency services",
    accStep3Desc: "Police: 17 · Ambulance: 15 · Fire: 18 · European: 112",
    accStep4Title: "Contact your insurer",
    accStep4Desc: "Report the claim within 5 working days. Fill in the European accident report.",
    conStep1Title: "Date, time and location",
    conStep1Desc: "Write down the exact date, time and precise location of the accident.",
    conStep2Title: "Injuries?",
    conStep2Desc: "Indicate if there are any injuries, even minor ones.",
    conStep3Title: "Material damage",
    conStep3Desc: "Check if other vehicles or objects are damaged.",
    conStep4Title: "Witnesses",
    conStep4Desc: "Note the names and contact details of any witnesses.",
    conStep5Title: "Vehicle A & B",
    conStep5Desc: "Each driver fills in THEIR column. Check the other party's details.",
    conStep6Title: "Insurance details",
    conStep6Desc: "Exchange policy numbers, insurer names and contact details.",
    conStep7Title: "Accident sketch",
    conStep7Desc: "Draw a simple diagram: vehicle positions, direction of travel.",
    conStep8Title: "Signatures required",
    conStep8Desc: "BOTH drivers must sign. Each keeps a copy.",
    conStep9Title: "Never admit fault",
    conStep9Desc: "Do not sign any document without your insurer's agreement.",
    // Véhicule modification
    modifierVehicule: "✏️ Edit vehicle",
    enregistrerVehicule: "✅ Save",
    // Carburant litres
    litres: "LITRES",
    consoMoyenne: "AVG CONSUMPTION",
    // À propos
    aPropos: "About",
    version: "Version",
    carnetEntretien: "Smart maintenance logbook",
    compteConnecte: "Connected account",
    disponiblePremium: "🔒 Available with Premium",
    famille: "Family",
    installerApp: "📲 Install app on phone",
    installerAppUltra: "💎 Install app (Ultra)",
    notifActivees: "🔔 Notifications enabled ✓",
    activerNotif: "🔔 Enable notifications",
    notifPushUltra: "💎 Push notifications (Ultra)",
    confirmerSuppression: "⚠️ Confirm deletion",
    actionIrreversibleMdp: "This cannot be undone. Enter your password to confirm.",
    votreMdp: "Your password",
    supprimer: "🗑️ Delete",
    partagerAppTexte: "The vehicle maintenance logbook app 🚗",
    lienCopie: "✅ Link copied!",
    partagerApp: "🔗 Share app",
    cguPolitique: "📄 T&Cs & Privacy Policy",
    // Supprimer compte
    supprimerCompte: "Delete my account",
    supprimerCompteConfirm: "Are you sure? This action cannot be undone.",
    supprimerCompteBtn: "🗑️ Delete permanently",
    kilometrageCompteur: "ODOMETER READING",
    parcourus: "driven this month",
    kmActuel: "TOTAL VEHICLE KM",
    // Certificat
    certificatEntretien: "🔗 MAINTENANCE CERTIFICATE",
    bientotBlockchain: "Powered by CHECKAR — Coming to Blockchain",
    idCertificat: "CERTIFICATE ID",
    verifications: "Checks",
    interventions: "Services",
    genere: "Generated on",
    scannerCertificat: "Scan this QR code to verify the authenticity of the maintenance log",
    // Plans Premium
    planTitre: "Choose a plan",
    planSoustitre: "Level up your vehicle care 🚀",
    planPopulaire: "⭐ MOST POPULAR",
    planMois: "/mo",
    planOu: "or",
    planAn: "/yr",
    planGratuit: "Free",
    planActuel: "Your current plan",
    planPremiumBtn: "Go Premium 🔒",
    planUltraBtn: "Go Ultra Premium 💎",
    planSupportTitre: "⚡ Ultra Premium Priority Support",
    planSupportDesc: "Guaranteed reply within 24h by email. Our team handles your requests with top priority.",
    planFooter: "Secure payment · No commitment · Cancel anytime",
    planFreeF1: "1 vehicle", planFreeF2: "Full checklist", planFreeF3: "Documents & reminders",
    planFreeF4: "Emergency button 🆘", planFreeF5: "Expenses — current month", planFreeF6: "Stats — current month",
    planPremF0: "Everything in Free +", planPremF1: "Up to 3 vehicles", planPremF2: "Multilingual FR/EN (auto) 🌍", planPremF3: "AI dashboard diagnostics 🔍",
    planPremF4: "Expenses & km — 3 months", planPremF5: "History — 3 months", planPremF6: "Family sharing by code 👨‍👩‍👧",
    planPremF7: "PDF export 📄", planPremF8: "Stats — 3 months",
    planUltraF1: "Unlimited vehicles", planUltraF2: "Everything in Premium +", planUltraF3: "Installable PWA 📲",
    planUltraF4: "Push notifications 🔔", planUltraF5: "Unlimited expenses & km", planUltraF6: "Unlimited history",
    planUltraF7: "PDF export + OCR scanner 📷", planUltraF8: "OBD2 Diagnostics 🔌",
    planUltraF9: "Priority support ⚡ (24h)", planUltraF10: "Stats — 1 year",
    // Scanner OCR
    scannerFacture: "📷 Scan an invoice",
    analyseEnCours: "⏳ Analysing...",
    // Bienvenue
    bienvenue: "Welcome to CHECKAR! 🚗",
    bienvenueMsg: "Start by adding your vehicle to track its maintenance.",
    // Kilométrage
    kilometrage: "Mileage",
    kmActuel: "CURRENT KM",
    enCasAccident: "In case of accident",
    procedureSecurite: "Procedure · Safety · Assistance",
    guideConstat: "European accident report guide",
    remplirSansErreur: "Fill it out correctly step by step",
    servicesProches: "Nearby services",
    googleMapsOuvre: "Opens Google Maps near you 📍",
    retour: "← Back",
    procedureAccident: "🚨 Accident procedure",
    appelRapide: "QUICK CALL",
    pompiers: "Fire brigade",
    police: "Police",
    europe: "Europe",
    assuranceLabel: "Insurance",
    numerosUrgence: "EMERGENCY NUMBERS",
    pasNumeroAssurance: "📋 No insurance number saved",
    guideConstatTitle: "📋 European accident report guide",
    servicesProchesTitle: "📍 Nearby services",
    garageDépannage: "Garage / Breakdown",
    stationService: "Gas station",
  },
};
